/* beautiful-react-hooks version: 0.35.0 */
import { slicedToArray as _slicedToArray } from './_virtual/_rollupPluginBabelHelpers.js';
import { useState } from 'react';

var maybeState = function maybeState(state, defaultValue) {
  return state !== null && state !== void 0 ? state : defaultValue;
};

var useDefaultedState = function useDefaultedState(defaultValue, initialState) {
  var _useState = useState(maybeState(initialState, defaultValue)),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  var setStateSafe = function setStateSafe(nextState) {
    return setState(maybeState(nextState, defaultValue));
  };

  return [maybeState(state, defaultValue), setStateSafe];
};

export default useDefaultedState;
